//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fbButton, whatsapp, tw } from 'vanilla-sharing';

export default {
    props: {
        url: {
            type: String,
            default: '',
        },
    },

    methods: {
        shareTo(to) {
            const payload = {
                url: this.url,
            };

            switch (to) {
            case 'facebook':
                fbButton(payload);
                break;
            case 'whatsapp':
                whatsapp(payload);
                break;
            case 'twitter':
                tw(payload);
                break;
            default:
                break;
            }
        },
    },
};
